<template>
  <div class="org-selection-page">
    <div class="content-container">
      <div class="org-selection-nav">
        <img
          src="../../assets/images/erriff-health-logo.svg"
          alt="Erriff Health"
          class="org-selection-logo"
        />
        <router-link to="/login" class="form__link">Go to login</router-link>
      </div>
      <div class="page-header">
        <h1>
          Select Organization Type
          <help-icon help-id="orgselection" title="Help for Organization Selection" />
        </h1>
        <!-- <h2>Select Organization Type</h2> -->
      </div>

      <div class="org-types-grid">
        <div
          v-for="orgType in organizationTypes"
          :key="orgType.id"
          class="org-type-card"
          @click="navigateToOrgType(orgType)"
        >
          <div class="org-type-icon">
            <font-awesome-icon :icon="orgType.icon" />
          </div>
          <div class="org-type-content">
            <h3>{{ orgType.title }}</h3>
            <p>{{ orgType.description }}</p>
          </div>
          <div class="org-type-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelpIcon from "@/components/help/HelpIcon.vue";

export default {
  name: "OrgSelectionPage",
  components: {
    HelpIcon,
  },
  data() {
    return {
      organizationTypes: [
        {
          id: 1,
          slug: "medical-practice",
          title: "Medical Practice",
          description: "Set up registration for medical practices",
          icon: ["fas", "building"],
        },
        {
          id: 2,
          slug: "nursing-agency",
          title: "Nursing Agency",
          description: "Set up registration for nursing agencies",
          icon: ["fas", "user-nurse"],
        },
        // {
        //   id: 3,
        //   slug: "care-managing-agency",
        //   title: "Care Managing Agency",
        //   description: "Set up registration for care managing agencies",
        //   icon: ["fas", "clipboard-check"],
        // },
        // {
        //   id: 4,
        //   slug: "home-health-agency",
        //   title: "Home Health Agency",
        //   description: "Set up registration for home health agencies",
        //   icon: ["fas", "home"],
        // },
        // {
        //   id: 5,
        //   slug: "solo-medical-practice",
        //   title: "Solo Medical Practice",
        //   description: "Set up registration for solo practices",
        //   icon: ["fas", "user-md"],
        // },
        // {
        //   id: 6,
        //   slug: "independent-nursing",
        //   title: "Independent Nursing",
        //   description: "Set up registration for independent nursing",
        //   icon: ["fas", "user-nurse"],
        // },
        // {
        //   id: 7,
        //   slug: "independent-home-health-aide",
        //   title: "Independent Home Health Aide",
        //   description: "Set up registration for independent HHAs",
        //   icon: ["fas", "home"],
        // },
        // {
        //   id: 8,
        //   slug: "patient-with-family",
        //   title: "Patient with Family",
        //   description: "Set up registration for patient-and-family access",
        //   icon: ["fas", "users"],
        // },
        // {
        //   id: 9,
        //   slug: "patient",
        //   title: "Patient",
        //   description: "Set up registration for individual patient accounts",
        //   icon: ["fas", "user"],
        // },
      ],
    };
  },
  methods: {
    navigateToOrgType(orgType) {
      this.$router.push({
        name: "RegisterNavigation",
        query: { orgType: orgType.slug, orgTypeId: String(orgType.id) },
      });
    },
  },
};
</script>

<style scoped>
.org-selection-page {
  min-height: 100vh;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed;
  background-size: cover;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-container {
  background-color: #fff;
  padding: 3rem 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.org-selection-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.org-selection-logo {
  width: 100px;
  height: auto;
}

.org-selection-nav .form__link {
  color: #0c8687;
  font-size: 1.05rem;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.org-selection-nav .form__link:hover {
  color: #0a6f70;
  text-decoration: underline;
}

.page-header {
  text-align: center;
  margin-bottom: 3rem;
}

.page-header h1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.15rem;
  font-size: 2.5rem;
  font-weight: 700;
  color: #0c8687;
  margin: 0 0 0.5rem 0;
}

.page-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.org-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
}

.org-type-card {
  background-color: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1rem;
  border: 2px solid transparent;
}

.org-type-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #0c8687;
}

.org-type-icon {
  width: 60px;
  height: 60px;
  background-color: #0c8687;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.org-type-icon i {
  font-size: 1.5rem;
  color: white;
}

.org-type-content {
  flex: 1;
}

.org-type-content h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.org-type-content p {
  font-size: 0.875rem;
  color: #666;
  margin: 0;
}

.org-type-arrow {
  color: #0c8687;
  font-size: 1.2rem;
  opacity: 0.7;
}

.org-type-card:hover .org-type-arrow {
  opacity: 1;
}

@media only screen and (max-width: 768px) {
  .org-selection-page {
    padding: 1rem;
  }

  .content-container {
    padding: 2rem 1rem;
    max-height: 95vh;
  }

  .org-selection-nav {
    text-align: center;
  }

  .org-types-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .org-type-card {
    padding: 1rem;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .page-header h2 {
    font-size: 1.25rem;
  }
}
</style>
